
import { PinterestClient } from '@/SDK/pinterest/pinterest-client';
import { createSlice } from '@reduxjs/toolkit';






// Redux state types
export interface ReduxPinterestSessionRootState {
    pinterest: {
        client: PinterestClient;
    };

}

const initialState = {
    client: null,
};

const pinterest = createSlice({
    name: 'pinterest',
    initialState,
    reducers: {
        setPinterestClient: (state, action) => {
            state.client = action.payload;

            // console.log("New Pinterest Client Saved: ", action.payload);
        },
        clearPinterestClient: (state) => {

            state.client = null;

            console.log("Pinterest Client Cleared");
        },
    },
});

export const { setPinterestClient, clearPinterestClient } = pinterest.actions;
export default pinterest.reducer;
